export default "__VITE_ASSET__BjO2$d1c__"